import PropTypes from 'prop-types';
import React, { useState } from 'react';
import SimpleTable from 'ui/Table';
import Money from 'ui/formats/Money';
import DownloadLink from 'ui/DownloadLink';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
// import { Print } from '@material-ui/icons';

import ExpansionContainer from '../ExpansionContainer';
import formatters from '../../formatters';

function TransactionsHistory({ title, amount, currency, data, payment }) {
    const [opened, setOpened] = useState(false);

    const onChange = (opened, e) => {
        setOpened(opened);
    };

    const extra = opened ? (
        <div>
            <IconButton>
                <DownloadLink
                    color="primary"
                    href={`/api/partner/transactions/invoice/${payment.invoice_number}`}
                />
            </IconButton>
        </div>
    ) : (
        <Typography variant="h6" color="textSecondary">
            <Money amount={amount} currency={currency} />
        </Typography>
    );

    const headSmall = label => () => (
        <span style={{ fontSize: '0.8rem' }}>{label}</span>
    );

    const options = {
        header: [
            headSmall('Date'),
            headSmall('Qty'),
            headSmall('Description'),
            headSmall(`Amount (${currency})`),
        ],
        columns: [
            {
                styles: { align: 'left' },
                format: date => formatters.date(date, 'MMM DD, YYYY'),
            },
            {
                styles: { align: 'left' },
            },
            {
                styles: { align: 'left' },
            },
            {
                format: amount => <Money amount={amount} currency={currency} />,
                styles: { align: 'right' },
            },
        ],
        footer: [
            <Typography variant="subtitle2">
                {formatters.date(payment.date, 'MMM DD, YYYY')}
            </Typography>,
            null,
            <Typography variant="subtitle2">{payment.description}</Typography>,
            <Typography variant="subtitle2">
                {<Money amount={amount} currency={currency} />}
            </Typography>,
        ],
    };
    return (
        <ExpansionContainer
            title={title}
            extra={extra}
            onChange={onChange}
            wide
        >
            <SimpleTable options={options} data={data} />
        </ExpansionContainer>
    );
}

TransactionsHistory.propTypes = {
    title: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired,
    data: PropTypes.array.isRequired,
};

export default TransactionsHistory;
